import { REQUEST_RESET_PASSWORD_ERROR } from './constant'
import { GetterTree } from 'vuex'
import { UserState } from './types'

export const getters: GetterTree<UserState, any> = {
  [REQUEST_RESET_PASSWORD_ERROR]: state => state.requestResetPasswordError
}
